import { render } from "./BlogSmall.vue?vue&type=template&id=007db40e&scoped=true"
import script from "./BlogSmall.vue?vue&type=script&lang=js"
export * from "./BlogSmall.vue?vue&type=script&lang=js"

import "./BlogSmall.vue?vue&type=style&index=0&id=007db40e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007db40e"]])

export default __exports__